const IntroText = ({ isMobile, title, subTitle }) => {
  const subTitleList = subTitle?.split(", ") || [];
  return (
    <section className="flex flex-col gap-8">
      <h2
        className={` ${
          isMobile
            ? "typography-semantic-heading-1-bold"
            : "typography-semantic-title-2-bold"
        }`}
      >
        {title}
      </h2>
      {isMobile ? (
        <div className="typography-semantic-heading-3-bold">
          <p>{subTitleList[0]}, </p>
          <p className="text-palette-lumir-600">{subTitleList[1]}</p>
        </div>
      ) : (
        <p className="typography-semantic-heading-1-bold">
          {subTitleList[0]},{" "}
          <span className="text-palette-lumir-600">{subTitleList[1]}</span>
        </p>
      )}
    </section>
  );
};

export { IntroText };
